import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { show } from 'redux-modal'
import { lifecycle, withHandlers, withProps, withState } from 'recompose'
import BOTArticleDetails from './BOTArticleDetails'
import { setRelatedArticles } from '../actions'
import isEqual from 'lodash/isEqual'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { scrollToPreviousPositionOnThePage, generateArticlesSchema, getArticleImageSrcFromHTMLString, setMissingTagObserver } from './helpers'
import { getDescription, getCanonicalUrl } from 'components/Head/helpers'
import { ARTICLES_ACCORDION_MODAL } from 'components/BOTArticleCategories/constants'

export const mapStateToProps = ({ app: { data }}) => {
  let currentUrl = ''
  if (window && window.location) {
    currentUrl = window.location.href
  }
  return {
    canonicalUrl: data.canonical ? getCanonicalUrl(data) : currentUrl,
    description: data ? getDescription(data) : ''
  }
}

export const withArticleSchemasState = withState('articleGeneralSchema', 'setArticleGeneralSchema', null)

const setRelatedArticlesLifecycle = lifecycle({
  componentDidMount() {
    const {
      description,
      canonicalUrl,
      setArticleGeneralSchema,
      setRelatedArticles,
      articleDetail: {
        article: {
          relatedArticles = [],
          datePublished,
          name,
          body
        }
      }
    } = this.props
    setRelatedArticles({ relatedArticlesData: relatedArticles })
    scrollToPreviousPositionOnThePage()

    const image = getArticleImageSrcFromHTMLString(body) || null
    const articleGeneralSchema = generateArticlesSchema(canonicalUrl, description, name, image, datePublished)

    setArticleGeneralSchema(articleGeneralSchema)
    setMissingTagObserver()
  },
  componentDidUpdate({
    articleDetail: { article: { relatedArticles: prevRelatedArticles } = {}, article: prevArticle } = {}
  }) {
    const {
      setRelatedArticles,
      articleDetail: {
        article: {
          relatedArticles = []
        },
        article
      }
    } = this.props

    if (!isEqual(prevRelatedArticles, relatedArticles)) {
      setRelatedArticles({ relatedArticlesData: relatedArticles })
    }

    if (!isEqual(article, prevArticle)) {
      setMissingTagObserver()
    }
  },
  componentWillUnmount() {
    const {
      setRelatedArticles
    } = this.props

    setRelatedArticles({ relatedArticlesData: []})
  }
})


const withArticleCategoriesHandlers = withHandlers({
  showAccordionModal: ({
    show,
    articleDetail: {
      categoriesList
    }
  }) => () => {
    show(ARTICLES_ACCORDION_MODAL, { articleCategories: categoriesList })
  }
})

const withArticleQueryProps = withProps(({ articleDetail: {
  article: {
    serviceQueryParam,
    categoryQueryParam
  } = {}
} = {}}) => ({
  navigateToQuickApptPage: true,
  serviceQueryParam,
  categoryQueryParam
}))

export default compose(
  withType({ type: 'BOTArticleDetails' }),
  connect(mapStateToProps, { setRelatedArticles, show }),
  withArticleQueryProps,
  withRequestApptClick,
  withArticleSchemasState,
  setRelatedArticlesLifecycle,
  withArticleCategoriesHandlers
)(BOTArticleDetails)
